export default "__VITE_ASSET__DZOwqvwz__"